<template>
  <DefaultBackground>
    <section class="m-2 md:m-10">
      <div class="container mx-auto grid grid-cols-12 space-x-0 md:space-x-4">
        <DefaultCard class="col-span-12 md:col-span-8">
          <Heading>
            <template>Promotion Events</template>
            <template v-slot:right>
              <StyledButton
                type="primary"
                size="md"
                @click="showCreateModal = true"
                >Create</StyledButton
              >
            </template>
          </Heading>

          <!-- Events table -->
          <TableComponent
            class="mt-8"
            v-if="events"
            :data="events"
            :headers="['Name', 'Status', 'Date']"
            :keys="['name', 'status', 'start']"
          >
            <template v-slot:buttons="{ row }">
              <router-link :to="'/orders/' + row.uuid + '/edit/'">
                <StyledButton size="xs"> Edit </StyledButton>
              </router-link>
            </template>
          </TableComponent>

          <p v-else class="bg-gray-200 mt-4 p-2">
            No events found for this instance
          </p>
        </DefaultCard>

        <!-- sidebar -->
        <DefaultCard
          v-if="promotion"
          class="col-span-12 md:col-span-4 mt-4 md:mt-0"
        >
          <Heading>
            <template>Details</template>
            <template v-slot:right>
              <StyledButton
                type="secondary"
                size="xs"
                @click="showEditModal = true"
              >
                Edit
              </StyledButton>
            </template>
          </Heading>

          <div class="mt-8">
            <div class="font-semibold">Name</div>
            <div class="text-sm text-gray-700">{{ promotion.name }}</div>
          </div>

          <div class="mt-8">
            <div class="font-semibold">Logo</div>
            <div class="w-full h-20">
              <img class="object-contain w-full h-full" :src="promotion.logo" />
            </div>
          </div>

          <div class="mt-8">
            <div class="font-semibold">Url</div>
            <div class="text-sm text-gray-700">{{ promotion.url }}</div>
          </div>

          <div class="mt-8">
            <div class="font-semibold">Description</div>
            <div class="text-sm text-gray-700">{{ promotion.description }}</div>
          </div>
        </DefaultCard>
      </div>
    </section>

    <CreateEventModal
      v-if="showCreateModal"
      :promotionid="$route.params.id"
      @close="showCreateModal = false"
    />
    <CreateUpdatePromotionModal
      v-if="showEditModal"
      :promotion="promotion"
      @close="showEditModal = false"
      @refresh="loadData"
    />
  </DefaultBackground>
</template>

<script>
import DefaultBackground from "@/components/common/layout/DefaultBackground";
import DefaultCard from "@/components/common/layout/DefaultCard";
import Heading from "@/components/common/Heading";
import TableComponent from "@/components/common/TableComponent";
import StyledButton from "@/components/common/controls/StyledButton";
import CreateUpdatePromotionModal from "@/components/modals/promotion/CreateUpdatePromotionModal";
import CreateEventModal from "@/components/modals/promotion/CreateEventModal";
import ApiV1 from "@/api/api_v1.0";

export default {
  name: "promotionIndex",
  components: {
    DefaultBackground,
    DefaultCard,
    Heading,
    TableComponent,
    StyledButton,
    CreateUpdatePromotionModal,
    CreateEventModal
  },
  data() {
    return {
      promotion: null,
      showCreateModal: false,
      showEditModal: false
    };
  },

  computed: {
    events() {
      return this.promotion?.events ? this.promotion.events : null;
    }
  },

  async created() {
    this.loadData();
  },

  methods: {
    async loadData() {
      const response = await ApiV1.getPromotionDetails(this.$route.params.id);
      this.promotion = response.data;
    }
  }
};
</script>

<style></style>
